import {
	btn,
	Button,
	checkbox,
	CheckboxField,
	comp,
	Component,
	Config,
	cookies, DateField, datefield,
	DateTime,
	Field,
	fieldset,
	form,
	Form,
	h4,
	Notifier,
	numberfield,
	select,
	textfield,
	TextField
} from "@intermesh/goui";
import {CurrentParticipant} from "../services/CurrentParticipant.js";
import {ParticipantEntity} from "../data/ParticipantsStore.js";
import {t} from "../util/Translate.js";
import {customFieldsStore} from "../data/CustomFieldsStore.js";
import {ServerApi} from "../util/ServerApi.js";
import {IfwInvalidator} from "../util/IfwInvalidator.js";

export class RegistrationForm extends Component {
	[x: string]: any;

	public readonly form!: Form;

	public currentParticipant: ParticipantEntity | undefined;

	public usernameFld: TextField;
	public passwordFld: TextField;
	public emailFld: TextField;
	private passwordRepeatFld: TextField;

	private minAge: number | undefined;
	private minAgeWarning: Component;

	private mustCreateLogin = true;

	constructor(public readOnly: boolean = false) {
		const portalConfig = JSON.parse(localStorage.getItem("portalConfig")!);
		super();
		const fs = fieldset({
				cls: "",
			},
			comp({
					tagName: "div",
					cls: "ifw-title-cnt"
				},
				comp({
					tagName: "h3",
					cls: "ifw-title",
					text: this.readOnly ? t("Please confirm") : t("Please enter your details")
				}),
				comp({
					tagName: "h4",
					cls: "ifw-subtitle",
					text: t("Please confirm your input in the form below"),
					hidden: !this.readOnly
				}),
			),
			comp({
					cls: "row",
				},
				textfield({
					flex: 1,
					label: t("First name"),
					id: "firstName",
					name: "firstName",
					required: true,
					readOnly: this.readOnly,
					icon: "person",
					listeners: {
						invalid: IfwInvalidator.setTranslatedErrorMsg
					}
				}),
				textfield({
					flex: 1,
					label: t("Middle name"),
					name: "middleName",
					id: "middleName",
					required: false,
					readOnly: this.readOnly

				}),
				textfield({
					flex: 1,
					label: t("Last name"),
					id: "lastName",
					name: "lastName",
					required: true,
					readOnly: this.readOnly,
					listeners: {
						invalid: IfwInvalidator.setTranslatedErrorMsg
					}

				})
			),
			comp({cls: "row"},
			datefield({
				label: t("Date of birth"),
				id: "dateOfBirth",
				name: "dateOfBirth",
				cls: "with-icon",
				icon: "cake",
				required: true,
				readOnly: this.readOnly,
				// maxDate: new DateTime(), // today
				max: new DateTime().format("Y-m-d"), // today
				listeners: {
					invalid: IfwInvalidator.setTranslatedDateErrorMsg,
					change: (_field: DateField, newValue: string, _oldValue: string) => {
						this.minAgeWarning.hide();
						if (!this.minAge) {
							return true;
						}
						const now = new DateTime(), date = new DateTime(newValue);
						now.setHours(0).setMinutes(0).setSeconds(0).setMilliseconds(0).addYears((0 - this.minAge));
						if (date.compare(now) > 0) {
							this.minAgeWarning!.findChild("minAgeWarnText")!.text =
								t("Warning: On most of our locations, a minimum age of {age} years is set to be allowed to enter. Please check with your contact person.")
									.replace("{age}", this.minAge);
							this.minAgeWarning.show();
						}
					}
				}
			}),
			this.minAgeWarning = comp({cls: "hbox", flex: 1, hidden: true},
				btn({
					cls: "go-elearning-incident", icon: "warning", handler: () => {
					}, style: {paddingLeft: "2px", paddingRight: "8px"}
				}),
				comp({
					flex: 1, tagName: "p", id: "minAgeWarnText",
					text: ""
				})
			)),
			this.usernameFld = textfield({
				label: t("Username"),
				name: "user.username",
				id: "username",
				cls: "with-icon",
				icon: "account_circle",

				readOnly: this.readOnly,
				hidden: !this.mustCreateLogin,
				disabled: !this.mustCreateLogin,
				required: this.mustCreateLogin,
				listeners: {
					change: async (fld: TextField, newValue: string) => {
						ServerApi.call("elearning/frontend/participants/checkUserName", {userName: newValue}, "POST")
							.then((result) => {
								if (result.success) {
									if (result.userName) {
										fld.value = result.userName;
									}
								} else {
									fld.setInvalid(t("Sorry, this username is already taken"));
								}
							});
					}
				}
			}),

			comp({cls: "row"},
				this.passwordFld = textfield({
					type: "password",
					label: t("Password"),
					name: "user.password",
					id: "password",
					cls: "with-icon",
					icon: "lock",
					readOnly: this.readOnly,
					hidden: !this.mustCreateLogin,
					disabled: !this.mustCreateLogin,
					required: this.mustCreateLogin,
					listeners: {
						change: (fld: TextField, newValue: string) => {
							const dupe = this.passwordRepeatFld.value;
							if (dupe && dupe !== newValue) {
								this.passwordRepeatFld.setInvalid(t("The passwords don't match"));
							}
						},
						invalid: IfwInvalidator.setTranslatedErrorMsg
					}

				}),
				this.passwordRepeatFld = textfield({
					type: "password",
					label: t("Repeat Password"),
					name: "user.passwordRepeat",
					id: "passwordRepeat",
					// cls: "with-icon",
					readOnly: this.readOnly,
					hidden: !this.mustCreateLogin,
					disabled: !this.mustCreateLogin,
					required: this.mustCreateLogin,
					listeners: {
						change: (fld: TextField, newValue: string) => {
							const dupe = this.passwordFld.value;
							if (dupe && dupe !== newValue) {
								fld.setInvalid(t("The passwords don't match"))
							}
						},
						invalid: IfwInvalidator.setTranslatedErrorMsg
					},
					buttons: [
						this.togglepasswdBtn = btn({
							icon: "visibility", cls: "accent danger", handler: (btn: Button) => {
								const pi = this.passwordFld.input,
									pri = this.passwordRepeatFld.input;
								if (pi!.type === "password") {
									pi!.type = "text";
									pri!.type = "text";

									btn.icon = "visibility_off";
								} else {
									pi!.type = "password";
									pri!.type = "password";

									btn.icon = "visibility";
								}

							}, disabled: this.readOnly
						})
					]
				}),
			),

			textfield({
				label: t("Company"),
				name: "company",
				required: portalConfig.participant.requireCompany,
				readOnly: this.readOnly,
				icon: "domain"
			}),

			this.emailFld = textfield({
				label: t("Email"),
				name: "email",
				type: "email",
				required: portalConfig.participant.requireEmail,
				readOnly: this.readOnly,
				hint: t("Your e-mail address will only be used for creating your account and to send your certificate and reminders."),
				icon: "email",
				listeners: {
					invalid: IfwInvalidator.setTranslatedEmailErrorMsg
				}
			}),


			checkbox({
				name: "remindMe",
				id: "remindMe",
				label: t("Remind me by e-mail when my certificates are about to expire"),
				hidden: portalConfig.isEmployee,
				listeners: {
					change: (cb: CheckboxField, checked: boolean) => {
						this.form.findField("email")!.required = checked;
					}
				},
				disabled: this.readOnly
			})
		);

		this.form = form({
			handler: async () => {
				return await this.save();
			}
		}, fs);

		this.items.add(this.form);

	}


	async save() {
		Object.assign(this.currentParticipant!, this.form.value);
		sessionStorage.setItem("currentParticipant", JSON.stringify(this.currentParticipant));
	}

	async load() {
		try {
			super.mask();
			await this.setPreconditions();
			await this.getCustomFieldSets();
			this.currentParticipant = await CurrentParticipant.readIf();
			if (this.currentParticipant) {
				if (this.currentParticipant.id) {
					this.mustCreateLogin = false;
				}
				this.form.value = this.currentParticipant;
				// Dirty hack mode; set custom field values explicitly. I am not sure why these are not set automatically
				if(this.currentParticipant.id) {
					const cfs = this.currentParticipant.customFields || [];
					for(const [cfkey, cfvalue] of Object.entries(cfs)) {
						if(this.form.findField("customFields."+cfkey)) {
							this.form.findField("customFields."+cfkey)!.value = cfvalue;
						}
					}
				}
			}
		} catch (error: any) {
			Notifier.error(error.message);
		} finally {
			super.unmask();
		}
	}

	/**
	 * Set parameters for several use cases.
	 *
	 * @private
	 */

	private async setPreconditions() {
		const settingsUrl = ServerApi.url("settings")
		const globalSettings = await ServerApi.call(settingsUrl, {}, "GET");

		const configUrl = ServerApi.url("elearning/configuration/1");
		const elearningConfig = await ServerApi.call(configUrl, {}, "GET");

		this.passwordFld.hint = t(globalSettings.data.activePasswordRuleSet + "RuleSetText");

		this.minAge = elearningConfig.data.minimumAgeOfParticipants;
		const portalConfig = JSON.parse(localStorage.getItem("portalConfig")!);
		if (portalConfig.doGenerateCredentials && cookies.get("sectionAuth")) {
			this.mustCreateLogin = false;
		}
	}

	private async getCustomFieldSets() {
		const res = await customFieldsStore.load(),
			fieldsets = res.filter(r => r.displayFrontend);
		for (const cfs of fieldsets) {
			let fsTitle = cfs.name;
			if (cfs.readOnlyFrontend) {
				fsTitle += "&nbsp;<small>(" + t("Read-only") + ")</small>";
			}
			let ffs = fieldset({},
				h4({cls: "ifw-subtitle", html: fsTitle})
			);

			let items: Field[] = [];

			for (const cf of cfs.fields) {
				let fld;
				switch (cf.type) {
					case "text":
						fld = textfield({
							id: cf.databaseName + " " + cf.type,
							label: t(cf.name),
							name: "customFields." + cf.databaseName,
							icon: "star",
							cls: "with-icon",
							placeholder: cf.placeholder ? t(cf.placeholder) : " ",
							required: cf.required,
							readOnly: this.readOnly || cfs.readOnlyFrontend
						})
						break;
					case "number":
						fld = numberfield({
							id: cf.databaseName + " " + cf.type,
							label: t(cf.name),
							name: "customFields." + cf.databaseName,
							cls: "with-icon",
							icon: "star",
							placeholder: cf.placeholder ? t(cf.placeholder) : " ",
							required: cf.required,
							readOnly: this.readOnly || cfs.readOnlyFrontend
						})
						break;

					case "checkbox":
						fld = checkbox({
							id: cf.databaseName + " " + cf.type,
							label: t(cf.name),
							name: "customFields." + cf.databaseName,
							disabled: this.readOnly || cfs.readOnlyFrontend,
							required: cf.required
						});
						break;
					case "date":
						fld = datefield({
							id: cf.databaseName + " " + cf.type,
							label: t(cf.name),
							name: "customFields." + cf.databaseName,
							cls: "with-icon",
							icon: "event",
							required: cf.required,
							readOnly: this.readOnly || cfs.readOnlyFrontend,
							listeners: {
								invalid: IfwInvalidator.setTranslatedDateErrorMsg
							}
						});
						break;
					case "select":
						let fldOptions = [{value: "", name: ""}];
						for (const opt of cf.data.options) {
							fldOptions.push({value: opt, name: opt});
						}

						fld = select({
							id: cf.databaseName + " " + cf.type,
							label: t(cf.name),
							name: "customFields." + cf.databaseName,
							cls: "with-icon",
							icon: "star",
							required: cf.required,
							disabled: this.readOnly || cfs.readOnlyFrontend,
							options: fldOptions
						});

						break;
					default:
						console.warn("Unknown custom field type " + cf.type);
						continue;
				}
				if (cf.hintText) {
					fld!.hint = t(cf.hintText);
				}
				items.push(fld);
			}

			ffs.items.add(...items);
			this.form.items.add(ffs);
		}
	}

	public getAuthenticationData(): {user: {username: string, password: string}} {
		const userName = this.usernameFld.value, password = this.passwordFld.value;
		return {
			user: {
				username: userName,
				password: password
			}
		};
	}
}

export const registrationForm = (config?: Config<RegistrationForm>) => Object.assign(new RegistrationForm(config?.readOnly), config);